import { useSelector } from 'react-redux';
import AppLayout from '../components/global/layout/Layout.jsx';
import { Navigate } from 'react-router-dom';
import AuthLayout from '../components/global/layout/AuthLayout.jsx';

const ProtectedRoute = ({ type, children, title, image, accessUserRole }) => {

    const userDetails = useSelector((state) => state.user.userDetails);
    const { loggedIn } = useSelector(state => state.user);
    if (type === "private") {
        if (loggedIn) {
            if (accessUserRole) {   
                if (accessUserRole === userDetails?.role) {
                    return <AppLayout title={title} >{children}</AppLayout>
                } else {
                    return <Navigate to={userDetails?.role === 'admin' ? '/dashboard' : '/employee_dashboard'} replace />
                }
            } else {
                return <AppLayout title={title} >{children}</AppLayout>
            }
        } else {
            return <Navigate to="/login" replace />
        }
    }
    if (type === "public") {
        return children;
    }
    if (type === "auth") {
        if (!loggedIn) {
            return <AuthLayout image={image} title={title}>{children}</AuthLayout>;
        } else {
            return <Navigate to={userDetails?.role === 'admin' ? '/dashboard' : '/employee_dashboard'} replace />;
        }
    }
    return;
}

export default ProtectedRoute;